import {Suspense} from 'react';
import type {ReactElement} from 'react';

import PreLoading from '@/components/common/PreLoading';

const withSuspense = (element: ReactElement) => <Suspense fallback={<PreLoading />}>{element}</Suspense>;

export default withSuspense;
